export enum PaymentType {
  AdditionalSize = 'AdditionalSize',
  AdditionalUsers = 'AdditionalUsers',
  Credits = 'Credits',
  FirstSubscriptionActivated = 'FirstSubscriptionActivated',
  SharePoint = 'SharePoint',
  SubscriptionUpdated = 'SubscriptionUpdated',
  TeamDrive = 'TeamDrive'
}
